import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-profile",
  "use": "icon-cl-profile-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cl-profile\"><circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#F2F2F2\" /><circle cx=\"12\" cy=\"8\" r=\"3.5\" stroke=\"#555\" /><path d=\"M19 18c-1.688-1.688-3-4-7-4-3.5 0-5.312 2.312-7 4\" stroke=\"#555\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol